import { useCallback, useEffect, useRef } from 'react';

import { syncSuperDispatchLoads, syncSuperDispatchOrders, syncSuperDispatchStatus } from '../../API/loads';
import { RootState } from '../../store';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export function useSuperDispatchSync() {
  const dispatch = useAppDispatch();

  const superDispatchEnabled = useAppSelector((state: RootState) => !!state.carrierProfile.data?.superdispatch_enabled);
  const isSyncing = useAppSelector((state: RootState) => state.loads.isSyncing);

  const isSyncingRef = useRef(isSyncing);
  useEffect(() => {
    isSyncingRef.current = isSyncing;
  }, [isSyncing]);

  useEffect(() => {
    if (!superDispatchEnabled) {
      return;
    }

    dispatch(syncSuperDispatchLoads());

    let cancelled = false;
    const id = setInterval(async () => {
      if (cancelled || isSyncingRef.current) {
        return;
      }

      const shouldSync: boolean = await dispatch(syncSuperDispatchStatus()).unwrap();
      if (shouldSync) {
        dispatch(syncSuperDispatchLoads());
      }
    }, 30_000);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [superDispatchEnabled, dispatch]);

  const onSyncClick = useCallback(async () => {
    if (!superDispatchEnabled || isSyncingRef.current) {
      return;
    }

    await dispatch(syncSuperDispatchOrders());
    await dispatch(syncSuperDispatchLoads());
  }, [superDispatchEnabled]);

  return { onSyncClick, superDispatchEnabled, isSyncing };
}
